import { h, useAttributes, useEffect } from '@seahax/elemental';
import git from '@tabler/icons/outline/brand-git.svg?raw';
import linkedin from '@tabler/icons/outline/brand-linkedin.svg?raw';
import email from '@tabler/icons/outline/mail.svg?raw';
import news from '@tabler/icons/outline/news.svg?raw';

import { define } from '../utils/define.ts';
import style from './icon.css?inline';

const icons = { git, news, linkedin, email } as const;

export const Icon = define(
  (shadow) => {
    const [name] = useAttributes('icon-name');

    useEffect([name], (name) => {
      const text = getSvgText(name);
      if (!text) return;
      const el = h('template', { ':innerHTML': text }).content.firstElementChild!;
      shadow.appendChild(el);
      return () => el.remove();
    });
  },
  { tagName: 'ce-icon', styles: [style] },
);

function getSvgText(name: string | null) {
  return name != null && name in icons ? icons[name as keyof typeof icons] : null;
}
